/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum NumberFilterOperatorEnum {
    EQUAL = 'equalTo',
    BIGGER_THAN = 'biggerThan',
    EQUAL_BIGGER = 'equalOrBigger',
    SMALLER_THAN = 'smallerThan',
    EQUAL_SMALLER = 'equalOrSmaller',
    BETWEEN = 'between'
}
